export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10821.8459d882.jpg";